/**
 * Official wordmark from client/MycarslotLogo (copied to /public by scripts/build-brand-assets.mjs).
 * variant="onDark" uses Final logo white.svg for dark backgrounds (e.g. footer).
 */
export function brandLogoUrl(format = 'svg', variant = 'default') {
  const base = process.env.PUBLIC_URL || '';
  if (variant === 'onDark') {
    return `${base}/brand-logo-white.svg`;
  }
  return `${base}/brand-logo.${format}`;
}

export default function BrandLogo({ className = '', alt = 'MyCarSlot', format = 'svg', variant = 'default', ...rest }) {
  return (
    <img
      src={brandLogoUrl(format, variant)}
      alt={alt}
      className={className}
      decoding="async"
      {...rest}
    />
  );
}
